export default __webpack_public_path__ + "static/media/spinner.cb546845.gif";